import { GET_QUESTIONS_BY_IDENTIFIER } from '../../../src/client/cms/queries/questions-queries.gql';
import { nextReduxWrapper } from '../../../src/client/store/create-store';
import fetchAllProductData from '../../../src/client/models/product/fetch-all-product-data';
import getCmsData from '../../../src/client/cms/utils/get-cms-data';
import TaxPage from '../../../src/client/pages/campaigns/tax-time';

const TAX_QUESTIONS_IDENTIFIER = 'tax-page-faq';

export const getServerSideProps = nextReduxWrapper.getServerSideProps((store) => async () => {
  await fetchAllProductData(store.getState(), store.dispatch);

  const questionsData = await getCmsData(GET_QUESTIONS_BY_IDENTIFIER, {
    variables: { identifier: TAX_QUESTIONS_IDENTIFIER },
  });

  const questionsList = questionsData?.allQuestionsList ?? [];
  const otherSavingsQuestions = questionsList[0] ?? null;

  return { props: { otherSavingsQuestions } };
});

export default TaxPage;
